import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE } from 'constants/rightsCodes';

const DocumentTypePropertyStatesListItemComponent = ({ state, index, allowedStates, validation, onPropertyChanged, onDelete }) => {
  const [t] = useTranslation();
  const canWrite = usePermission(ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE);

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          label={t('DocumentTypes.DocumentTypeProperty.States.StateName')}
          value={state.documentStateId}
          simpleValue
          options={allowedStates}
          valueKey='documentStateId'
          labelKey='documentStateName'
          onChange={event => onPropertyChanged('documentStateId', event, index)}
          error={!isValid(validation[index].documentStateId)}
          helperText={getErrors(validation[index].documentStateId)}
          isSearchable={true}
          disabled={!canWrite}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.allowEdit}
              color='primary'
              onChange={event => onPropertyChanged('allowEdit', event.target.checked, index)}
              disabled={!canWrite}
            />
          }
        />
      </TableCell>
      <TableCell>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Delete')}
          onClick={onDelete(index)}
          disabled={!canWrite}
        />
      </TableCell>
    </TableRow>
  );
};

DocumentTypePropertyStatesListItemComponent.propTypes = {
  state: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  allowedStates: PropTypes.array,
  validation: PropTypes.object,
  onPropertyChanged: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DocumentTypePropertyStatesListItemComponent;
